"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMediaIcons = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
const SocialMediaIcons = exports.SocialMediaIcons = {
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Facebook]: 'facebook',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.VKontakte]: 'vkontakte',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Twitter]: 'twitter',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.YouTube]: 'youtube',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Instagram]: 'instagram',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Odnoklassniki]: 'odnoklassniki',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Weibo]: 'weibo',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Pinterest]: 'pinterest',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.QQ]: 'qq',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Youku]: 'youku',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Line]: 'youtube',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.WeChat]: 'wechat',
  [_staticApiClientReact.StaticApplicationsFooterBffSocialMediaLinkDtoType.Telegram]: 'telegram'
};